import { Loader } from '@googlemaps/js-api-loader';
import { CONFIG } from '~/_shared/constants/config';
import { i18n } from '../../../i18nextSetup';

let loadPromise: Promise<typeof google.maps> | undefined;
let viewerCountry: Maybe<string>;

export const setGoogleMapViewerCountry = (country: Maybe<string>) => {
  viewerCountry = country;
};

const getBrowserRegion = (): string | undefined => {
  try {
    return new Intl.Locale(navigator.language).region;
  }
  catch {
    return undefined;
  }
};

const getRegion = (): string | undefined => {
  const browserRegion = getBrowserRegion();

  if (!browserRegion || browserRegion?.toUpperCase() === 'US') {
    return viewerCountry?.toUpperCase() === 'US' ? 'US' : 'CA';
  }

  return browserRegion ?? 'CA';
};

export const loadGoogleMapsScript = () => {
  if (loadPromise) {
    return loadPromise;
  }

  const loader = new Loader({
    apiKey: CONFIG.GOOGLE_MAPS_API_KEY,
    libraries: ['geometry', 'drawing', 'visualization'],
    version: '3',
    channel: 'maptive',
    language: i18n.language,
    region: getRegion(),
  });

  loadPromise = loader.load().then(() => {
    return window.google.maps;
  });

  return loadPromise;
};
